import { AddressResponse } from "../sdk/types"

const checkAddress = (address?: AddressResponse) => {
    if (!address) return false

    const { pattern, personal, company, street, street_no, post_no, packstation, postoffice, zip, city, country } = address

    if (!country) return false
    if (!zip) return false
    if (!city) return false
    if (!pattern) return false

    if (pattern === "Default") {
        if (!street) return false
        if (!street_no) return false
    } else if (pattern === "Packstation") {
        if (!packstation) return false
        if (!post_no) return false
    } else if (pattern === "Postfiliale") {
        if (!postoffice) return false
        if (!post_no) return false
    } else if (pattern === "freieEingabe") {
        if (!street) return false
    }

    if (company) {
        if (!company.name) return false
    } else if (personal) {
        if (!personal.gender) return false
        if (!personal.firstname) return false
        if (!personal.lastname) return false
    }

    return true
}

export { checkAddress }
